import { Form } from './Form'
import { Header } from './Header'

const Step3 = {
  Header,
  Form,
}

export default Step3
